import { render, staticRenderFns } from "./addQuestBank.vue?vue&type=template&id=95ee8506&scoped=true&"
import script from "./addQuestBank.vue?vue&type=script&lang=js&"
export * from "./addQuestBank.vue?vue&type=script&lang=js&"
import style0 from "./addQuestBank.vue?vue&type=style&index=0&id=95ee8506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ee8506",
  null
  
)

export default component.exports